<template>
	<span>
		<a
			href="#"
			:class="['action', { 'loading': removing }]"
			v-b-tooltip
			:title="title"
			@click.prevent="onClick"
		>
			<Icon :icon="exclusionType !== null ? 'plus-circle' : 'minus-circle'"/>
		</a>
		<PopUp
			v-if="showRemovePopUp"
			title="Job wieder anzeigen"
			ok-text="OK"
			@ok="removeExclusion"
			@hidden="showRemovePopUp = false"
		>
			Job wieder in der Matchingliste anzeigen?
		</PopUp>
	</span>
</template>

<script>
import Loading from "@/vue/common/Loading";
import Exclusion from "@/api/application/job-profile/Exclusion";
import Icon from "@/vue/icon/Icon";
import {mapActions} from "vuex";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";
import PopUp from "@/vue/common/PopUp.vue";

const EXCLUSION_TYPE_TOTAL = 'total';
const EXCLUSION_TYPE_JOB = 'job';

export default {

	components: {
		PopUp,
		Loading,
		Icon,
	},

	props: {
		jobProfileItem: {
			type: Object,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
		exclusion: {
			type: Object,
			required: false
		}
	},

	data ()
	{
		return {
			localExclusion: this.exclusion,
			removing: false,
			showRemovePopUp: false
		};
	},

	computed: {
		exclusionType ()
		{
			if (!this.localExclusion)
			{
				return null;
			}

			return this.localExclusion?.total
				? EXCLUSION_TYPE_TOTAL
				: EXCLUSION_TYPE_JOB;
		},
		title ()
		{
			if (!this.localExclusion)
			{
				return 'Leider kein Interesse';
			}

			return 'Job wieder in der Matchingliste anzeigen'
		},
	},

	methods: {
		...mapActions('jobResult/exclusion/jobProfile', {
			openExclusionFan: 'show',
		}),
		onClick ()
		{
			if (!this.localExclusion)
			{
				this.openExclusionFan({
					jobProfileItem: this.jobProfileItem,
					jobId: this.jobId,
					onExclude: ({exclusionType}) =>
					{
						Event.push(
							new EventData()
								.setEvent(Event.EXCLUSION)
								.setAction('Hinzugefügt')
						);

						this.localExclusion = {
							total: exclusionType === EXCLUSION_TYPE_TOTAL
						};

						this.$emit('change', this.localExclusion);
					}
				});

				return;
			}

			Event.push(
				new EventData()
					.setEvent(Event.EXCLUSION)
					.setAction('Entfernt')
			);

			this.showRemovePopUp = true;
		},
		onExclude ({exclusionType})
		{
			this.exclusionType = exclusionType;
		},
		async removeExclusion ()
		{
			this.showRemovePopUp = false;

			if (this.removing)
			{
				return;
			}

			this.removing = true;

			try
			{
				await new Exclusion()
					.remove()
					.setType(this.exclusionType)
					.setJob(this.jobId)
					.setJobProfileId(this.jobProfileItem.id)
					.call();

				this.localExclusion = null;

				this.$emit('change', this.localExclusion);
			}
			catch (e)
			{
			}

			this.removing = false;
		}
	},

	watch: {
		exclusion (v)
		{
			this.localExclusion = v;
		}
	}
}
</script>
